export interface CompanyLocation {
  id: number;
  companyId?: number | null;
  name: string;
  address: string;
  city: string;
  state?: string | null;
  postalCode?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  plusCode?: string | null;
  active: boolean;
  allowPickup: boolean;
  allowReturn: boolean;
  defaultPickup: boolean;
  defaultReturn: boolean;
  primaryCompanyAddress?: boolean;
  servesAirport: boolean;
  servesPort: boolean;
  displayLabel?: string;
  createdAt?: string;
  updatedAt?: string;
}

// Every point does both pickup and return, and only the company address location is ever the
// default pickup/return point - neither is settable per point, so this upsert shape omits
// allowPickup/allowReturn/defaultPickup/defaultReturn entirely (the backend ignores/derives
// them regardless of what's sent).
export interface CompanyLocationUpsertRequest {
  name: string;
  address: string;
  city: string;
  state?: string | null;
  postalCode?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  plusCode?: string | null;
  active: boolean;
  servesAirport: boolean;
  servesPort: boolean;
}

export interface GeocodeResult {
  latitude: number;
  longitude: number;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  plusCode?: string | null;
}

export const formatCompanyLocationLabel = (location?: Partial<CompanyLocation> | null) => {
  if (!location) {
    return '';
  }

  if (location.displayLabel && location.displayLabel.trim()) {
    return location.displayLabel.trim();
  }

  // Kept short on purpose: street + city is enough to identify a location, and state/
  // postal code/country just make this label unwieldy (Albania barely uses either).
  const addressParts = [location.address, location.city].filter(Boolean);
  const addressLabel = addressParts.join(', ');

  if (location.name && addressLabel) {
    return `${location.name} - ${addressLabel}`;
  }

  return location.name || addressLabel;
};
